import { faAngleRight, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../utils/context";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllUSDTWallets,
  SetUSDTWallet,
} from "../../../features/wallet/slice";
import { maskAccountNumber } from "../../../utils/common";

function USDT_Bank_Card_Content() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { signin } = useContext(Context);

  const selectedUSDTWallet = useSelector(
    (state) => state.wallet.selectedUSDTWallet,
  );
  const usdtWallets = useSelector((state) => state.wallet.usdtWallets);

  const bank = selectedUSDTWallet?.usdt_address
    ? selectedUSDTWallet
    : usdtWallets?.find((b) => b.id === selectedUSDTWallet?.id) || null;

  useEffect(() => {
    if (signin) dispatch(GetAllUSDTWallets({}));
  }, [dispatch, signin]);

  useEffect(() => {
    if (usdtWallets?.length === 0) {
      localStorage.removeItem("selected_wallet_id");
    }
  }, [usdtWallets]);

  return (
    <section className="Bank_Card_Content">
      <section className="Withdraw_bank_info">
        <div className="bank_row" onClick={() => navigate("/usdt-addresses")}>
          <div className="row align-items-center">
            {/* Bank Icon */}
            <div className="col-4">
              <div className="bank_left">
                <div className="bank_icon">
                  <img
                    src="/assets/images/withdraw_Deposite/Payment_Method_Cards/usdt.png"
                    className="bank_img"
                    alt="bank img"
                  />
                  {/* {bank?.usdt_address && (
                    <p className="bank_name">{bank?.usdt_address}</p>
                  )} */}
                </div>
              </div>
            </div>

            {/* Account number or warning */}
            <div className="col-6">
              <div className="bank_right">
                {bank?.usdt_address ? (
                  // Bank selected — show masked number
                  <span>{bank?.usdt_address || "N/A"}</span>
                ) : (
                  // No bank selected — show warning
                  <span style={{ color: "#fc5c5d", fontSize: "13px" }}>
                    ⚠ No Address selected.{" "}
                  </span>
                )}
              </div>
            </div>

            {/* Arrow */}
            <div className="col-2">
              <div className="bank_right">
                <FontAwesomeIcon icon={bank ? faAngleRight : faPlus} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
}

export default USDT_Bank_Card_Content;
